import { z } from 'zod';

const Trigger = z.enum(['immediately', 'scroll', 'delay']);

const ImmediatelyTriggerSchema = z.object({
  trigger: z.literal(Trigger.enum.immediately).describe('The widget will trigger immediately upon loading.').optional(),
});

const ScrollSchema = z.object({
  trigger: z.literal(Trigger.enum.scroll),
  scrollThreshold: z
    .number()
    .describe('Threshold percentage of page scroll to trigger the widget when set to scroll.')
    .min(0)
    .max(100),
});

const DelaySchema = z.object({
  trigger: z.literal(Trigger.enum.delay),
  delayTimeInMs: z.number().describe('Delay time in milliseconds to trigger the widget when set to delay.'),
});

export const TriggerUnionSchema = z.discriminatedUnion('trigger', [
  ScrollSchema,
  DelaySchema,
  ImmediatelyTriggerSchema,
]);

export const TriggerOptionSchema = z.object({
  trigger: Trigger,
});
